import type { ComponentType } from 'react';
import type { RouteObject } from 'react-router';

/** apps/web が集約する。ルート単位で遅延ロード（03 第 I 部 §2） */
type PageModule = { default: ComponentType };

function page(load: () => Promise<PageModule>): RouteObject['lazy'] {
  return async () => {
    const m = await load();
    return { Component: m.default };
  };
}

export const relationshipRoutes: RouteObject[] = [
  // 未確定の名寄せ（§17.5 ②）。/relationship は現時点ではここに寄せる
  { path: '/relationship', lazy: page(() => import('./pages/UnmatchedPage.js')) },
  { path: '/relationship/unmatched', lazy: page(() => import('./pages/UnmatchedPage.js')) },
  // 顧客の関係プロファイル（§17.6）。crm の顧客詳細から遷移する独立ページ
  { path: '/relationship/customers/:customerId', lazy: page(() => import('./pages/CustomerRelationshipPage.js')) },
  // 従業員側（§17.7）。:userId に 'me' を渡すと自分
  { path: '/relationship/users/:userId', lazy: page(() => import('./pages/UserRelationshipPage.js')) },
];
